// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-page {
  min-height: 100%;
}

.lt-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.lt-toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 200px;
}

.lt-search {
  flex: 1 1;
  max-width: 360px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.lt-search input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 15px;
  color: #0f172a;
  background: transparent;
  min-width: 0;
}

.lt-search input::placeholder {
  color: #94a3b8;
}

.lt-filter {
  padding: 7px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #475569;
  background: #fff;
  cursor: pointer;
}

.lt-count {
  font-size: 15px;
  color: #94a3b8;
  white-space: nowrap;
}

.lt-btn-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.lt-btn-refresh:hover {
  background: #f8fafc;
  color: #0f172a;
}

.lt-table-wrap {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.lt-table-scroll {
  overflow-x: auto;
}

.lt-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

.lt-table thead th {
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #fafbfc;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

.lt-table thead th:nth-child(1) { width: 24%; }
.lt-table thead th:nth-child(4) { width: 14%; }
.lt-table thead th:nth-child(6) { width: 10%; }
.lt-table thead th:last-child { width: 72px; text-align: right; }

.lt-sort-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.lt-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.lt-table tbody tr {
  cursor: pointer;
  transition: background 0.12s;
}

.lt-table tbody tr:hover {
  background: #f8fafc;
}

.lt-table tbody tr:last-child td {
  border-bottom: none;
}

.lt-org-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-org-email {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-status {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.02em;
}

.lt-status--active { background: #ecfdf5; color: #047857; }
.lt-status--expired { background: #fef2f2; color: #b91c1c; }
.lt-status--revoked { background: #f1f5f9; color: #64748b; }
.lt-status--paused { background: #fffbeb; color: #b45309; }
.lt-status--deleted { background: #f3f4f6; color: #9ca3af; }

.lt-expiry-date {
  color: #334155;
  font-weight: 500;
}

.lt-expiry-left {
  display: block;
  font-size: 13px;
  margin-top: 1px;
}

.lt-expiry-left.ok { color: #64748b; }
.lt-expiry-left.warn { color: #b45309; }
.lt-expiry-left.bad { color: #dc2626; }

.lt-ip {
  font-family: ui-monospace, monospace;
  font-size: 15px;
  color: #64748b;
}

.lt-muted {
  color: #94a3b8;
  font-size: 15px;
}

.lt-usage {
  font-size: 15px;
  color: #64748b;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.lt-usage strong {
  color: #334155;
  font-weight: 600;
}

.lt-actions {
  text-align: right;
  position: relative;
}

.lt-icon-btn {
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  color: #94a3b8;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lt-icon-btn:hover {
  background: #f1f5f9;
  color: #475569;
}

.lt-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  width: 140px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 50;
  padding: 4px;
}

.lt-dropdown button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  background: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  text-align: left;
}

.lt-dropdown button:hover {
  background: #f8fafc;
}

.lt-dropdown-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 4px 0;
}

.lt-empty {
  padding: 40px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.lt-loading {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.lt-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
  font-size: 15px;
  color: #64748b;
}

.lt-pagination-btns {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lt-page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
  font-size: 15px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.lt-page-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.lt-page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-page-btn.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.lt-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.25);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lt-loading-box {
  background: #fff;
  padding: 20px 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #64748b;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}

.animate-spin {
  animation: lt-spin 0.8s linear infinite;
}

@keyframes lt-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/LicenseTable.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,gCAAgC,WAAW,EAAE,iBAAiB,EAAE;;AAEhE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB,cAAc,EAAE;AACrC,uBAAuB,cAAc,EAAE;AACvC,sBAAsB,cAAc,EAAE;;AAEtC;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".lt-page {\n  min-height: 100%;\n}\n\n.lt-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.lt-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 200px;\n}\n\n.lt-search {\n  flex: 1;\n  max-width: 360px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.lt-search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 15px;\n  color: #0f172a;\n  background: transparent;\n  min-width: 0;\n}\n\n.lt-search input::placeholder {\n  color: #94a3b8;\n}\n\n.lt-filter {\n  padding: 7px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #475569;\n  background: #fff;\n  cursor: pointer;\n}\n\n.lt-count {\n  font-size: 15px;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.lt-btn-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.lt-btn-refresh:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.lt-table-wrap {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.lt-table-scroll {\n  overflow-x: auto;\n}\n\n.lt-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 15px;\n}\n\n.lt-table thead th {\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: #fafbfc;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.lt-table thead th:nth-child(1) { width: 24%; }\n.lt-table thead th:nth-child(4) { width: 14%; }\n.lt-table thead th:nth-child(6) { width: 10%; }\n.lt-table thead th:last-child { width: 72px; text-align: right; }\n\n.lt-sort-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.lt-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n  vertical-align: middle;\n}\n\n.lt-table tbody tr {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.lt-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.lt-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.lt-org-name {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n  font-size: 15px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-org-email {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-status {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: capitalize;\n  letter-spacing: 0.02em;\n}\n\n.lt-status--active { background: #ecfdf5; color: #047857; }\n.lt-status--expired { background: #fef2f2; color: #b91c1c; }\n.lt-status--revoked { background: #f1f5f9; color: #64748b; }\n.lt-status--paused { background: #fffbeb; color: #b45309; }\n.lt-status--deleted { background: #f3f4f6; color: #9ca3af; }\n\n.lt-expiry-date {\n  color: #334155;\n  font-weight: 500;\n}\n\n.lt-expiry-left {\n  display: block;\n  font-size: 13px;\n  margin-top: 1px;\n}\n\n.lt-expiry-left.ok { color: #64748b; }\n.lt-expiry-left.warn { color: #b45309; }\n.lt-expiry-left.bad { color: #dc2626; }\n\n.lt-ip {\n  font-family: ui-monospace, monospace;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.lt-muted {\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.lt-usage {\n  font-size: 15px;\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-usage strong {\n  color: #334155;\n  font-weight: 600;\n}\n\n.lt-actions {\n  text-align: right;\n  position: relative;\n}\n\n.lt-icon-btn {\n  width: 30px;\n  height: 30px;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-icon-btn:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.lt-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  width: 140px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  z-index: 50;\n  padding: 4px;\n}\n\n.lt-dropdown button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.lt-dropdown button:hover {\n  background: #f8fafc;\n}\n\n.lt-dropdown-divider {\n  height: 1px;\n  background: #f1f5f9;\n  margin: 4px 0;\n}\n\n.lt-empty {\n  padding: 40px 16px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.lt-loading {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 5;\n}\n\n.lt-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.lt-pagination-btns {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.lt-page-btn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  color: #64748b;\n  font-size: 15px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.lt-page-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.lt-page-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-page-btn.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.lt-loading-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.25);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-loading-box {\n  background: #fff;\n  padding: 20px 24px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  color: #64748b;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n}\n\n.animate-spin {\n  animation: lt-spin 0.8s linear infinite;\n}\n\n@keyframes lt-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
